import PropTypes from 'prop-types';
import React, { lazy, useState } from 'react';

import Box from '@material-ui/core/Box';
import { mediaUrls } from 'globalconfig/constants/mediaUrls';
import { hasEnabledSettings, hasValue, isdvirOnlyUser } from 'globalutils/fmUtils';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import TopActions from './TopActions';

const getInspectionStatusValue = (item) => {
  const status = item?.status;
  if (status == null || status === '') {
    return '-';
  }
  if (typeof status === 'object') {
    return status.name ?? status.value ?? status.label ?? '-';
  }
  return status;
};

const getViolationStatusCriteria = (violationType) => {
  if (violationType === 'DISTANCE') {
    return (
      <div
        class="circle_orange csadvirAlign"
        title="Minimum Distance condition is not satisfied"
      ></div>
    );
  }
  if (violationType === 'DURATION') {
    return (
      <div
        class="circle_yellow csadvirAlign"
        title="Minimum Duration condition is not satisfied"
      ></div>
    );
  }
  if (violationType === 'BOTH') {
    return (
      <div
        class="circle_red csadvirAlign"
        title="Minimum Distance & Minimum Duration conditions are not satisfied"
      ></div>
    );
  }
  if (violationType === 'NONE' || violationType === null) {
    return '-';
  }
  if (violationType === 'OK') {
    return (
      <div class="circle_green csadvirAlign" title="Completed correctly"></div>
    );
  }
  return <div class="wrapOpt"></div>;
};

const layout = window?.$environment?.CURRENT_LAYOUT;
const Message = lazy(() => import(`globalcomponents/UI/Message/${layout}`));
const Table = lazy(() => import(`globalcomponents/UI/Table/${layout}`));
const Icon = lazy(() => import(`globalcomponents/UI/Icon/${layout}`));
const Modal = require(`globalcomponents/UI/Modal/${layout}`).default;

const Index = ({ theme, filters, ...contentProps }) => {
  return (
    <Box style={{ ...theme.palette.contentStyle, overflowX: 'hidden' }}>
      <Component {...contentProps} filters={filters} />
    </Box>
  );
};
export default Index;

const Component = ({
  apiStatus,
  callback,
  history,
  Styled,
  fetchInspections,
  bulkDownloadReport,
  inspections,
  list,
  changeRequest,
  isAdvancedDviRequired,
  isCustomDviRequired,
  logBook,
  clearApiStatus,
  i18n,
  topAction,
  getDocumentToken,
  filters,
  viewReport,
  request,
  pagination,
  setPagination,
  needSort,
  rowsPerPage,
  setRowsPerPage,
}) => {
  const [open, setOpen] = useState(false);
  // const [currentItem, setCurrentItem] = useState();

  const [ModalObject, setModalObject] = useState({
    header: '',
    content: () => {
      return null;
    }
  });

  const closeModal = (event) => {
    setOpen(false);
  };
  const beBaseUrl = window?.$environment?.BE_BASE_URL;
  const hasApiStatus = hasValue(apiStatus.status, 'api', fetchInspections);
  const information =
    hasApiStatus && hasApiStatus.errorMessage ? (
      <Message type="error" s message={i18n.t(hasApiStatus.errorMessage)} />
    ) : (
      i18n.t('common.tableEmptyMessage')
    );
  const showInspectionStatusInFm = hasEnabledSettings('SHOW_INSPECTION_STATUS_IN_FM');
  const hideViolationStatusDots = showInspectionStatusInFm && isdvirOnlyUser();
  const columns = [
    {
      id: 'date',
      numeric: false,
      disablePadding: false,
      label: i18n.t('accidents.dateAndTime'),
      needSorting: true
    },
    {
      id: 'assetName',
      numeric: false,
      disablePadding: false,
      label: i18n.t('inspections.assetsName'),
      needSorting: true
    },
    {
      id: 'unitType',
      numeric: false,
      disablePadding: false,
      label: i18n.t('inspections.unitType'),
      needSorting: true
    },
    {
      id: 'driver',
      numeric: false,
      disablePadding: false,
      label: i18n.t('common.driverName'),
      needSorting: true
    },
    {
      id: 'type',
      numeric: false,
      disablePadding: false,
      needSorting: needSort,
      label: i18n.t('inspections.inspectionType'),
    },
    ...(showInspectionStatusInFm
      ? [
          {
            id: 'inspectionStatus',
            numeric: false,
            disablePadding: false,
            needSorting: false,
            label: i18n.t('inspections.inspectionStatus', 'Inspection Status'),
          },
        ]
      : []),
    {
      id: 'document',
      numeric: false,
      disablePadding: false,
      label: i18n.t('common.photos')
    },
    {
      id: 'report',
      numeric: false,
      disablePadding: false,
      label: i18n.t('inspections.inspectionReport')
    },
    ...(window.$environment.SERVICE_PROVIDER == 'spireon' ? [{
      id: 'status',
      numeric: false,
      disablePadding: false,
      label: i18n.t('logs.status')
    }] : []),
    ...(!hideViolationStatusDots
      ? [
          {
            id: 'criteria',
            numeric: false,
            disablePadding: false,
            label:
              window.$environment.SERVICE_PROVIDER == 'spireon'
                ? 'Criteria'
                : i18n.t('logs.status'),
          },
        ]
      : []),
  ];

  if (window.$environment.CURRENT_LAYOUT === 'SpireonNew') {
    columns.splice(6, 0, {
      id: 'hasDefect',
      numeric: false,
      disablePadding: false,
      label: i18n.t('inspections.hasDefects')
    })
  }
  if (window.$environment.SERVICE_PROVIDER === 'edvir') {
    columns.splice(6, 1)
  }
  // useEffect(() => {
  //   currentItem && viewPicture();
  // }, [currentItem]);
  const viewPictureCallback = (type, data, currentItem) => {
    currentItem &&
      setModalObject({
        header: '',
        content: () => {
          return (
            <Carousel
              showIndicators={false}
              showThumbs={false}
              showStatus={false}
            >
              {currentItem.photos.map((photo) => {
                return (
                  <div>
                    <img
                      src={`${beBaseUrl}/document/open/${photo.files[0].id}?token=${data}`}
                    />
                    <p className="legend">
                      {`${photo?.sectionName}${photo?.info ? ` : ${photo?.info}` : ""}`}
                    </p>
                  </div>
                );
              })}
            </Carousel>
          );
        }
      });
    setOpen(true);
  };
  const viewPicture = (item) => {
    getDocumentToken({
      apiId: 'getDocToken',
      callback: viewPictureCallback,
      item: item
    });
  };

  const generateRows = () => {
    const updatedList = inspections?.content?.map((result) => {
      let item = { ...result };
      item.report = (
        <a
          // href={`${beBaseUrl}/document/open/${item?.id}?token=${logBook?.documentToken}`}
          className="viewReport"
          // target="_blank"
          onClick={() =>
            viewReport({
              apiId: 'viewReportApi',
              data: item?.id
            })
          }
        >
          {i18n.t('inspections.viewReport')}
        </a>
      );
      if (!hideViolationStatusDots) {
        item.criteria = getViolationStatusCriteria(item.violationType);
      }
      if (showInspectionStatusInFm) {
        item.inspectionStatus = getInspectionStatusValue(item);
      }
      item.document = item.photos.length ? (
        window.$environment.CURRENT_LAYOUT === 'SpireonNew' ? (
          <a
            onClick={() => {
              // setCurrentItem(item);
              viewPicture(item);
            }}
          >
            {i18n.t('View')}
          </a>
        ) : (
          <Icon
            src={mediaUrls?.full}
            tableicon
            onClick={() => {
              // setCurrentItem(item);
              viewPicture(item);
            }}
          ></Icon>
        )
      ) : window.$environment.CURRENT_LAYOUT === 'SpireonNew' ? (
        ''
      ) : (
        <Icon src={mediaUrls?.notFull} tableicon></Icon>
      );
      item.hasDefect = item?.hasDefect ? i18n.t('common.yes') : i18n.t('common.no');
      return item;
    });
    return updatedList || [];
  };
  return (
    <Styled.Wrapper>
      {topAction && (
        <TopActions
          {...{
            isAdvancedDviRequired,
            isCustomDviRequired,
            i18n,
            history,
            list,
            bulkDownloadReport,
            apiStatus,
            clearApiStatus,
            callback,
            Styled,
            changeRequest,
            hasApiStatus,
            filters,
            request,
            pagination,
            setPagination
          }}
        />
      )}
      <div className="quickFilter"></div>
      <Styled.TableWrapper>
        <div className="driverstatusTitle">
          <span className="spireonOldOnly">
            Inspections
          </span>
        </div>
        <Table
          type="server"
          defaultSortBy={needSort ? { sortBy: 'type', order: 'desc' } : null}
          changeRequest={changeRequest}
          baseRequest={request}
          title=""
          columns={[...columns]}
          data={generateRows()}
          emptyMessage={information}
          itemsPerPage={rowsPerPage}
          totalRecords={inspections?.totalCount}
          actions={[]}
          i18n={i18n}
          pageinationReset={pagination}
          pagenationClicked={(e) => {
            setPagination(!e);
          }}
        />
      </Styled.TableWrapper>
      <Modal
        open={open}
        setOpen={setOpen}
        data={ModalObject}
        onCloseModal={closeModal}
        background="black"
        inspectionPopup
        withCloseIcon
      />
    </Styled.Wrapper>
  );
};

Component.propTypes = {
  history: PropTypes.object.isRequired,
  apiStatus: PropTypes.object.isRequired,
  callback: PropTypes.func.isRequired,
  fetchViolations: PropTypes.func.isRequired,
  handleExportCsaViolations: PropTypes.func.isRequired
};
